export interface IContactResponse {
  first_name: string;
  last_name: string;
}

export interface IContactData {
  firstName: string;
  lastName: string;
}

export const convertIContactResponseToIContactData = ({ first_name, last_name }: IContactResponse): IContactData => ({
  firstName: first_name,
  lastName: last_name,
});

export const convertIContactDataToIContactResponse = ({ firstName, lastName }: IContactData): IContactResponse => ({
  first_name: firstName,
  last_name: lastName,
});
